<template>
  <div class="service-grid-item">
    <div class="service-grid-item__image">
      <div class="service-grid-item__image-wrapper">
        <router-link to="/service-details">
          <img
            :src="$backendPublic + service.image"
            class="img-fluid"
            :alt="service.title"
          />
        </router-link>
      </div>
      <div v-if="service.icon" class="icon">
        <i :class="service.icon"></i>
      </div>
    </div>
    <div class="service-grid-item__content">
      <h3 class="title">
        <router-link to="/service-details">
          {{ service.title }}
        </router-link>
      </h3>
      <p class="subtitle" v-html="service.desc"></p>
      <router-link class="see-more-link" to="/service-details"
        >بیشتر</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["service"],
}
</script>
